import {request} from "../../base/HTTP";
import HttpMethod from "../../constants/HttpMethod";

export async function addAdmin(data) {
    return await request('/api/superadmin/admins', data, HttpMethod.POST);
}

